import { Routes } from '@angular/router';
// guard
import { authGuard, loginGuard, adminGuard } from '@app/auth/guard/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/data-management', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () => import('src/app/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [loginGuard],
    data: { title: 'Login' },
  },
  {
    path: 'signup',
    loadChildren: () => import('src/app/routes/signup/signup.routes').then((m) => m.SIGNUP_ROUTES),
    canActivate: [loginGuard],
    data: { title: 'Sign Up' },
  },
  {
    path: 'register',
    loadChildren: () => import('src/app/routes/register/register.route').then((m) => m.REGISTER_ROUTES),
    canActivate: [loginGuard],
    data: { title: 'Register' },
  },
  {
    path: 'terms-of-service',
    loadChildren: () =>
      import('./routes/terms-of-service/terms-of-service.module').then((m) => m.TermsOfServiceModule),
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./routes/privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyModule),
  },
  {
    path: 'main',
    loadChildren: () => import('src/app/routes/main/main.module').then((m) => m.MainModule),
    canActivate: [authGuard],
    data: { title: 'Main' },
  },
  // * AI Scanning 페이지
  {
    path: 'ai-scanning',
    loadChildren: () => import('src/app/routes/ai-scanning/ai-scanning.module').then((m) => m.AiScanningModule),
    canActivate: [authGuard],
    data: { title: 'AI Scanning' },
  },
  // * Export to Excel 페이지
  {
    path: 'export-excel',
    loadChildren: () =>
      import('src/app/routes/export-excel/export-excel.module').then((m) => m.ExportExcelModule),
    canActivate: [authGuard],
    data: { title: 'Export to Excel' },
  },
  // * Cargo Tracking 페이지
  {
    path: 'cargo-tracking',
    loadChildren: () => import('src/app/routes/tracking/tracking.module').then((m) => m.TrackingModule),
    canActivate: [authGuard],
    data: { title: 'Cargo Tracking' },
  },
  // * Data Management 페이지
  {
    path: 'data-management',
    loadChildren: () =>
      import('src/app/routes/data-management/data-management.routes').then((m) => m.DATA_MANAGEMENT_ROUTES),
    canActivate: [authGuard],
  },
  // * Template Setting 페이지
  {
    path: 'template-setting/:templateSeq',
    loadChildren: () =>
      import('src/app/routes/template-setting/template-setting.routes').then((m) => m.TEMPLATE_SETTING_ROUTES),
    canActivate: [authGuard],
  },
  // * Link Editor 페이지
  {
    path: 'link-editor',
    loadChildren: () => import('src/app/routes/link-editor/link-editor.routes').then((m) => m.LINK_EDITOR_ROUTES),
    canActivate: [authGuard],
  },
  // * Warehouse Management(WMS) 페이지
  {
    path: 'warehouse-management',
    loadChildren: () =>
      import('src/app/routes/warehouse-management/warehouse-management.routes').then(
        (m) => m.WAREHOUSE_MANAGEMENT_ROUTES,
      ),
    canActivate: [authGuard],
  },
  // * Inventory Management 페이지
  {
    path: 'inventory-management',
    loadChildren: () =>
      import('src/app/routes/inventory-management/inventory-management.routes').then(
        (m) => m.INVENTORY_MANAGEMENT_ROUTES,
      ),
    canActivate: [authGuard],
  },
  // * Freetime Management 페이지
  {
    path: 'freetime/management',
    loadChildren: () =>
      import('src/app/routes/freetime/management/management.routes').then((m) => m.FREETIME_MANAGEMENT_ROUTES),
    canActivate: [authGuard],
  },
  // * Freetime Detail 페이지
  {
    path: 'freetime/detail',
    loadChildren: () =>
      import('src/app/routes/freetime/detail/detail.routes').then((m) => m.FREETIME_DETAIL_ROUTES),
    canActivate: [authGuard],
  },
  // * 신고관리 (화주용) 페이지
  {
    path: 'shipper-declaration',
    loadChildren: () =>
      import('src/app/routes/shipper-declaration/shipper-declaration.routes').then(
        (m) => m.SHIPPER_DECLARATION_ROUTES,
      ),
  },
  // * 신고관리 (관세사용) 페이지
  {
    path: 'broker-declaration',
    loadChildren: () =>
      import('src/app/routes/broker-declaration/broker-declaration.routes').then(
        (m) => m.BROKER_DECLARATION_ROUTES,
      ),
  },
  // * 신고상세 페이지
  {
    path: 'declaration/:declarationSeq/:declarationType',
    loadChildren: () =>
      import('src/app/routes/declaration-detail/declaration-detail.routes').then(
        (m) => m.DECLARATION_DETAIL_ROUTES,
      ),
  },
  // * 파트상세 페이지
  {
    path: 'declaration/:declarationSeq/:declarationType/product/:productSeq',
    loadChildren: () =>
      import('src/app/routes/declaration-part-detail/declaration-part-detail.routes').then(
        (m) => m.DECLARATION_PART_DETAIL_ROUTES,
      ),
  },
  // * 엔지니어 작성 요청 폼 페이지
  {
    path: 'equipment-engineer/:id',
    loadChildren: () =>
      import('src/app/routes/equipment-engineer/equipment-engineer.routes').then(
        (m) => m.EQUIPMENT_ENGINEER_ROUTES,
      ),
    canActivate: [],
  },
  // * 파트 프린트 페이지
  {
    path: 'part-print',
    loadChildren: () =>
      import('src/app/routes/declaration-part-print/declaration-part-print.routes').then(
        (r) => r.PART_PRINT_ROUTES,
      ),
    canActivate: [authGuard],
  },
  // * 유사사례 페이지
  {
    path: 'case',
    loadChildren: () => import('src/app/routes/case/case.routes').then((m) => m.CASE_ROUTES),
    canActivate: [authGuard],
  },
  // * 유사사례 상세 페이지
  {
    path: 'case/:id',
    loadChildren: () => import('src/app/routes/case-detail/case-detail.routes').then((m) => m.CASE_DETAIL_ROUTES),
    canActivate: [authGuard],
  },
  // * 관리자 페이지
  {
    path: 'admin',
    // loadChildren: () => import('src/app/routes/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
    loadChildren: () =>
      import('src/app/routes/employee-management/employee-management.route').then(
        (m) => m.EMPLOYEE_MANAGEMENT_ROUTES,
      ),
    canActivate: [authGuard, adminGuard],
  },
  // * 통계 페이지
  {
    path: 'statistics',
    loadChildren: () => import('src/app/routes/statistics/statistics.routes').then((m) => m.STATISTICS_ROUTES),
    canActivate: [authGuard],
  },
  // * ACO 페이지
  {
    path: 'aco',
    loadChildren: () => import('src/app/routes/aco/aco.routes').then((m) => m.ACO_ROUTES),
    canActivate: [authGuard],
  },
  // * ACB 신고 페이지
  {
    path: 'acb-declare',
    loadChildren: () => import('src/app/routes/acb-declare/acb-declare.routes').then((m) => m.ACB_DECLARE_ROUTES),
    canActivate: [authGuard],
  },
  // * ACB 경정청구 페이지
  {
    path: 'acb-refund',
    loadChildren: () => import('src/app/routes/acb-refund/acb-refund.routes').then((m) => m.ACB_REFUND_ROUTES),
    canActivate: [authGuard],
  },
  // * 마이 페이지
  {
    path: 'my-page',
    loadChildren: () => import('./routes/my-page/my-page.routes').then((m) => m.MY_PAGE_ROUTES),
    canActivate: [authGuard],
  },
  // * 사원 관리 페이지
  {
    path: 'employee-management',
    loadChildren: () =>
      import('./routes/employee-management/employee-management.route').then((m) => m.EMPLOYEE_MANAGEMENT_ROUTES),
    canActivate: [authGuard],
  },
  // * 초대 수락 페이지
  {
    path: 'invitation/accept',
    loadChildren: () => import('./routes/invitation/invitation.route').then((m) => m.INVITATION_ROUTES),
  },
  // * 비밀번호 수정 메일 발송 페이지
  {
    path: 'forget-password',
    loadChildren: () =>
      import('./routes/forget-password/forget-password.route').then((m) => m.FORGET_PASSWORD_ROUTES),
  },
  // * 비밀번호 재설정
  {
    path: 'reset-password',
    loadChildren: () =>
      import('./routes/reset-password/reset-password.route').then((m) => m.RESET_PASSWORD_ROUTES),
  },
  // ?===============================================================================
  {
    path: 'showcase',
    loadChildren: () => import('src/app/routes/showcase/showcase.module').then((m) => m.ShowcaseModule),
    canActivate: [authGuard],
    data: { title: 'Showcase' },
  },

  {
    path: '**',
    loadComponent: () =>
      import('src/app/shared/components/not-found/not-found.component').then((c) => c.NotFoundPageComponent),
  },
];
